// @flow
import React from 'react';
import CONF from '../../../api/config';
import { FEATURES } from '../../features/components/constants';
import openCalendarMessagingSummaryDrawer from '../../messaging/state/openCalendarMessagingSummaryDrawer';
import useHomeEvents from '../../home/components/hooks/useHomeEvents';
import FeatureFlag from '../../features/components/FeatureFlag';
import CalendarMessagingDrawer from '../../../view/calendar/components/CalendarMessagingDrawer';

const NOW = Date.now();
const ALERTS_PATH = `${CONF.ADAPTER}/alerts?timestamp=${NOW}`;

const getDirectMessagePath = (
    athleteId: number,
    teamId: number,
    programWorkoutId: number,
    dateString: string,
    sessionId: string
) => {
    /* eslint-disable */
    return `${
        CONF.ADAPTER
    }/messaging/direct/${athleteId}?timestamp=${NOW}&teamId=${teamId}&programWorkoutId=${programWorkoutId}&date=${dateString}&sessionId=${sessionId}`;
};

const getTeamMessagePath = teamId => {
    /* eslint-disable */
    return `${CONF.ADAPTER}/messaging/team/${teamId}?timestamp=${NOW}`;
};

export default function Alerts() {
    const {
        directMessageSession,
        directMessageDrawerAthleteId,
        setDirectMessageDrawerAthleteId,
        teamChannelTeamId,
        setTeamChannelTeamId
    } = useHomeEvents(openCalendarMessagingSummaryDrawer);

    const {
        id: sessionId,
        teamId,
        programWorkoutId,
        dateString
    } = directMessageSession.current;

    const directMessagePath = getDirectMessagePath(
        directMessageDrawerAthleteId,
        teamId,
        programWorkoutId,
        dateString,
        sessionId
    );

    return (
        <FeatureFlag feature={FEATURES.MOBILE_LOW_PROGRAMMING}>
            <iframe
                title="alerts"
                frameBorder="none"
                style={{ border: 'none' }}
                src={ALERTS_PATH}
                allowFullScreen={true}
                className="content-width alerts-frame"
            />
            {directMessageDrawerAthleteId && (
                <CalendarMessagingDrawer
                    path={directMessagePath}
                    messageDrawerOpen={true}
                    onClose={() => {
                        setDirectMessageDrawerAthleteId(null);
                    }}
                />
            )}
            {teamChannelTeamId && (
                <CalendarMessagingDrawer
                    path={getTeamMessagePath(teamChannelTeamId)}
                    messageDrawerOpen={true}
                    onClose={() => {
                        setTeamChannelTeamId(null);
                    }}
                />
            )}
        </FeatureFlag>
    );
}



// WEBPACK FOOTER //
// ./src/v5/notifications/components/Alerts.jsx